export default "__VITE_ASSET__D7dmNdXT__"